<template>
	<div id="footer">
		<div class="company">
			<div class="info">
				<h5>选购指南</h5>
				<div>
					手机
				</div>
				<div>
					手表
				</div>
				<div>
					平板
				</div>
				<div>
					耳机
				</div>
			</div>
			<div class="info">
				<h5>关于我们</h5>
				<div>
					公司介绍
				</div>
			</div>
			<div class="info">
				<h5>宏眸APP</h5>
				<div>
					ios下载
				</div>
				<div>
					Android下载
				</div>
			</div>
			<div class="info4">
				<h5>联系我们</h5>
				<div>
					客服电话：{{info.config_phone}}
				</div>
				<div>
					邮件：{{info.config_email}}
				</div>
				<div>
					公司名称：{{info.web_site_name}}
				</div>
				<div>
					地址：{{info.config_address}}
				</div>
			</div>
		</div>

		<div class="record">
			<div>
				<img src="@/assets/img/logo_black.png" alt="" />
				<span>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{info.config_beian}}
					</a>版权：宏眸有限公司</span>
			</div>
			<div></div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		name: "Footer",
		data() {
			return {
				info: '',
				domain: '',
			};
		},
		mounted() {
			// 如果需要包含协议，可以这样组合
			this.domain = `${window.location.protocol}//${window.location.hostname}`;
			this.getInfo()
		},
		methods: {
			getInfo() {
				// 发起 POST 请求
				axios.post(this.domain + '/api/login/info')
					.then(response => {
						console.log('响应数据:', response.data);
						this.info = response.data.data
					})
					.catch(error => {
						console.error('请求出错:', error);
					});
			},
		}
	};
</script>
<style scoped>
	#footer {
		height: 357px;
		transition: all ease 0.6s;
		background: #F7F7F7;
		box-sizing: border-box;
		text-align: left;
	}

	.company {
		width: 57%;
		margin: 0 auto;
		/* height: 277px; */
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
	}

	.record {
		height: 80px;
		box-sizing: border-box;
		background: white;
		padding: 20px;
		font-size: 12px;
		color: #999999;
		display: flex;
		justify-content: space-around;
	}

	.record img {
		width: 36px;
		height: 40px;
		display: inline-block;
	}



	.record span {
		margin-left: 14px;
	}

	.info,
	.info4 {
		margin-top: 50px;

	}

	.info div,
	.info4 div {
		line-height: 30px;
		color: #666666;
		font-size: 14px;
	}

	.info h5,
	.info4 h5 {
		font-weight: 800;

	}

	@media screen and (min-width:998px) {
		.company {
			height: 277px;
		}

	}



	@media screen and (max-width: 997px) {
		.title {
			font-size: 20px;
		}

		.address_tel_fax {
			font-size: 12px;
		}

		.email_wx {

			font-size: 12px;
		}

		.copy {
			font-size: 12px;
			margin: 30px 0 10px;
		}

		.info {
			display: none;
		}

		.info4 {
			margin-top: 0px;
		}

		.company {
			width: 90%;
			padding: 30px 0;
			/* height: 220px; */
		}

		#footer {
			height: 300px;
		}


	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue